export function parseCssPx(value: string, fallback: number): number {
  const parsed = Number.parseFloat(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

export function syncSpeechSnakeGeometry(button: HTMLElement): void {
  const snake = button.querySelector<SVGSVGElement>(
    '.liks-chat-composer__speech-snake',
  );
  const path = button.querySelector<SVGRectElement>(
    '.liks-chat-composer__speech-snake-path',
  );
  if (snake == null || path == null) {
    return;
  }

  const styles = window.getComputedStyle(button);
  const width = Math.max(1, button.offsetWidth);
  const height = Math.max(1, button.offsetHeight);
  const borderWidth = parseCssPx(styles.borderTopWidth, 1);
  const outerRadius = parseCssPx(styles.borderTopLeftRadius, 8);
  const inset = borderWidth / 2;
  const radius = Math.max(0, outerRadius - inset);

  snake.setAttribute('viewBox', `0 0 ${width} ${height}`);
  path.setAttribute('x', String(inset));
  path.setAttribute('y', String(inset));
  path.setAttribute('width', String(Math.max(0, width - inset * 2)));
  path.setAttribute('height', String(Math.max(0, height - inset * 2)));
  path.setAttribute('rx', String(radius));
  path.setAttribute('ry', String(radius));
}
